import { VAULT } from 'constants/icons';
import { Text } from 'destiny';
import MaskedAccountNumber from 'modules/accounts-mea/components/MaskedAccountNumber';
import { AccountByVaultIdType } from 'types/accountsApi.types';
import Currency from 'components/currency/Currency';

export const getSelectedSourceAccountCardProps = ({
  sourceAccount,
  isMeaView,
}: {
  sourceAccount: AccountByVaultIdType;
  isMeaView?: boolean;
}) => {
  return isMeaView
    ? {
        title: (
          <div className='tw-flex tw-gap-2'>
            <Text textClass='f-14-400 tw-text-TEXT_PRIMARY tw-truncate'>
              {sourceAccount?.name ?? sourceAccount?.display_name ?? ''}
            </Text>
            {sourceAccount?.masked_number && (
              <MaskedAccountNumber
                maskedAccountNumber={sourceAccount?.masked_number ?? ''}
                textClassName='f-14-400 tw-text-TEXT_PRIMARY'
              />
            )}
          </div>
        ),
        subtitle: sourceAccount?.parentEntity?.name,
        customIcon: (
          <Currency
            code={sourceAccount?.currency_code}
            showName={false}
            hideTooltip
            customIconDimensions={{ width: 30, height: 30 }}
          />
        ),
      }
    : {
        title: sourceAccount?.name,
        subtitle: sourceAccount?.entity_name,
        iconPath: VAULT,
      };
};
